import {setupLiveToggle, isLive} from './liveToggle'
import debouncedRefresh from './debouncedRefresh'
import managedSubscription from './managedSubscription'
import connectionStatus from './connectionStatus'

const DEFAULT_DEBOUNCE = 3000
const subscription = managedSubscription()
const refreshers = {}
let refreshIfLive = () => {}
const connection = connectionStatus(() => refreshIfLive())

$(document).on('turbo:load', function() {
  const config = $('#cable')?.data() || {}

  if (config.channel != 'EventsChannel') {
    subscription.clear()
    return
  }

  const {channel, eventId, updates, debounce = DEFAULT_DEBOUNCE} = config
  const refresh = refreshers[debounce] || (refreshers[debounce] = debouncedRefresh(debounce))
  refreshIfLive = () => { if (isLive(channel)) refresh.next() }

  setupLiveToggle(channel)

  subscription.ensure(config, {channel: channel, eventId: eventId}, {
    // ActionCable calls these on the subscription: connected() once the server confirms it, initially and
    // after every reconnect; disconnected() when the websocket drops.
    connected: connection.connected,
    disconnected: connection.disconnected,

    received(data) {
      if (updates.includes(data.update)) {
        switch(data.update) {
          case 'new-check-ins':
          case 'new-scores':
          case 'new-start-times':
            if (isLive(channel)) {
              refresh.next()
            }
            break
          case 'new-alerts':
            $('#alerts-badge').text(data.alerts)
            break
          default:
            throw `Unmatched update on EventsChannel: ${data}`
        }
      }
    }
  })
})
